import { getAssetUrl } from "@utils/getAssetUrl";

/** 文字疊在圖片上的位置（相對圖片，%），文字中心對齊此點。 */
export interface WallpaperTextPos {
	top: string;
	left: string;
}

export interface Wallpaper {
	id: number;
	src: string;
	/** 每張圖的文字顯示位置（逐張微調） */
	textPos: WallpaperTextPos;
}

/**
 * 每張圖的文字位置。目前依示意圖粗估（多數在下半部、水平置中），
 * 細節請逐張微調 top / left。
 */
const TEXT_POS: Record<number, WallpaperTextPos> = {
	1: { top: "84%", left: "50%" },
	2: { top: "84%", left: "50%" },
	3: { top: "84%", left: "50%" },
	4: { top: "84%", left: "50%" },
	5: { top: "84%", left: "50%" },
	6: { top: "84%", left: "50%" },
	7: { top: "84%", left: "50%" },
	8: { top: "84%", left: "50%" },
	9: { top: "84%", left: "50%" },
	10: { top: "84%", left: "50%" },
	11: { top: "84%", left: "50%" },
	12: { top: "84%", left: "50%" },
	13: { top: "84%", left: "50%" },
	14: { top: "84%", left: "50%" },
};

/** 桌布圖檔（public/images/campaign-wallpaper/wallpaper-1..14.webp）。 */
export const WALLPAPERS: Wallpaper[] = [
	1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
].map((n) => ({
	id: n,
	src: getAssetUrl(`/images/campaign-wallpaper/wallpaper-${n}.webp`),
	textPos: TEXT_POS[n],
}));

/** 依 id 取桌布，找不到回傳 undefined。 */
export function findWallpaper(
	id: number | null | undefined,
): Wallpaper | undefined {
	if (id == null) return undefined;
	return WALLPAPERS.find((w) => w.id === id);
}
